import { render, staticRenderFns } from "./MakeEffectiveEmailStatusSlot.vue?vue&type=template&id=d913bfa6&"
import script from "./MakeEffectiveEmailStatusSlot.vue?vue&type=script&lang=js&"
export * from "./MakeEffectiveEmailStatusSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports